import { Modal, ModalTitle } from "@vds/modals";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { IconWrapper, Img, TextWrapper, Wrapper } from "../../constants/common/StyledGlobalConstants";
import CloseIcon from "../../assets/icons/CPCloseIcon.svg";
import "./RedesignedModal.css";
import styled from "styled-components";

const CFSTIconWrapper = styled(IconWrapper)`
  &:focus::before {
    outline: none;
  }
`;

const RedesignedModal = ({
  opened,
  onClickClose,
  title,
  children,
  button,
  zIndex,
  isScrollable,
  closeIconId = "modal-close-icon-button",
}) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClickClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  return (
    <>
      {opened && (
        <Modal
          role="dialog"
          aria-labelledby="dialog-title"
          aria-describedby="dialog-content"
          opened={true}
          id={isScrollable ? "scrollable-customised-modal" : "customised-modal"}
          surface="light"
          fullScreenDialog={false}
          disableAnimation={false}
          disableOutsideClick={true}
          viewport="desktop"
          zIndex={zIndex}
          closeButton={
            
              <Wrapper aria-label={"Header"} display="grid" gridTemplateColumns="97% 3%" marginBottom="1rem">
                <ModalTitle style={{ width: "auto" }}>
                  <TextWrapper id="dialog-title" fontWeight="bold" marginTop="0px" marginBottom="0px" fontSize="24px" width="90%" lineHeight="2rem">
                    {title}
                  </TextWrapper>
                </ModalTitle>
                <CFSTIconWrapper isFocusable={true} onClick={onClickClose} onMouseDown={(e) => e.preventDefault()} id={closeIconId}>
                  <Img aria-label="Closes the modal" role="img" src={CloseIcon} style={{ cursor: "pointer" }} zIndex="1"></Img>
                </CFSTIconWrapper>
              </Wrapper>
            
          }
        >
          <Wrapper>
            {children}
            {!isScrollable && <Wrapper className="customised-modal-button-wrapper">{button}</Wrapper>}
          </Wrapper>
        </Modal>
      )}
    </>
  );
};

RedesignedModal.propTypes = {
  opened: PropTypes.bool,
  onClickClose: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  button: PropTypes.node,
  zIndex: PropTypes.number,
  isScrollable: PropTypes.bool,
  closeIconId: PropTypes.string,
};

RedesignedModal.defaultProps = {
  opened: false,
  onClickClose: {},
  title: "",
  children: null,
  button: {},
  isScrollable: false,
};

export default RedesignedModal;
